import { render, staticRenderFns } from "./ReportHeaders.vue?vue&type=template&id=58039053&scoped=true"
import script from "./ReportHeaders.vue?vue&type=script&lang=js"
export * from "./ReportHeaders.vue?vue&type=script&lang=js"
import style0 from "./ReportHeaders.vue?vue&type=style&index=0&id=58039053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58039053",
  null
  
)

export default component.exports